/**
 * Klassey — theme.js
 * Comportamentos globais:
 *  - Cart drawer AJAX (open/close, add/change/remove, Section Rendering API)
 *  - Search drawer com predictive search via /search/suggest.json
 *  - Wishlist (customer metafield klassey.wishlist) — exige cliente logado
 *  - Mobile menu drawer
 *  - PDP gallery thumbnail sync
 */
(function () {
  "use strict";

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  // ===============================================================
  // Cart drawer
  // ===============================================================
  var CART_SEL = "[data-klassey-cart-drawer]";
  var CART_SECTION_ID = "cart-drawer";

  function openCart() {
    var d = $(CART_SEL); if (!d) return;
    d.setAttribute("aria-hidden", "false");
    d.classList.remove("pointer-events-none");
    var ov = $("[data-klassey-cart-overlay]", d);
    var pn = $("[data-klassey-cart-panel]", d);
    if (ov) { ov.classList.remove("opacity-0"); ov.classList.add("opacity-100"); }
    if (pn) pn.classList.remove("translate-x-full");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var d = $(CART_SEL); if (!d) return;
    d.setAttribute("aria-hidden", "true");
    var ov = $("[data-klassey-cart-overlay]", d);
    var pn = $("[data-klassey-cart-panel]", d);
    if (ov) { ov.classList.add("opacity-0"); ov.classList.remove("opacity-100"); }
    if (pn) pn.classList.add("translate-x-full");
    setTimeout(function () { d.classList.add("pointer-events-none"); }, 500);
    document.body.style.overflow = "";
  }

  function updateCartBadge(count) {
    $$("[data-klassey-cart-count]").forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.classList.remove("hidden"); el.classList.add("flex"); }
      else { el.classList.add("hidden"); el.classList.remove("flex"); }
    });
  }

  function refreshCartDrawer() {
    return fetch("/?sections=" + CART_SECTION_ID, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[CART_SECTION_ID]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector(CART_SEL);
        var current = $(CART_SEL);
        if (fresh && current) {
          var wasOpen = current.getAttribute("aria-hidden") === "false";
          current.innerHTML = fresh.innerHTML;
          bindCartHandlers();
          if (wasOpen) openCart();
        }
      })
      .catch(function (err) { console.warn("klassey: cart refresh failed", err); });
  }

  function fetchCartState() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); return cart; });
  }

  function addToCart(form, e) {
    e.preventDefault();
    var btn = e.submitter || form.querySelector("[data-klassey-buy-now]") || form.querySelector("[data-klassey-add-to-cart]");
    var originalText;
    if (btn) {
      btn.disabled = true;
      originalText = btn.textContent.trim();
      btn.textContent = "adicionando...";
    }

    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: new FormData(form),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return Promise.all([refreshCartDrawer(), fetchCartState()]); })
      .then(function () {
        var returnInput = form.querySelector('input[name="return_to"]');
        if (returnInput && returnInput.value) {
          window.location.href = returnInput.value;
          return;
        }
        openCart();
      })
      .catch(function (err) {
        console.error("klassey: add to cart failed", err);
        alert(err.description || err.message || "não foi possível adicionar ao carrinho.");
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText || "+ comprar"; }
      });
  }

  function changeLineByKey(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([refreshCartDrawer(), fetchCartState()]); });
  }

  function bindCartHandlers() {
    var d = $(CART_SEL); if (!d) return;
    var ov = $("[data-klassey-cart-overlay]", d);
    if (ov) ov.addEventListener("click", closeCart);
    $$("[data-klassey-cart-close]", d).forEach(function (b) { b.addEventListener("click", closeCart); });
    $$("[data-klassey-cart-qty]", d).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-key");
        var action = btn.getAttribute("data-klassey-cart-qty");
        var line = btn.closest("[data-klassey-cart-item]");
        var disp = line && line.querySelector("[data-klassey-cart-qty-display]");
        var current = parseInt((disp && disp.textContent) || "1", 10);
        var next = action === "increase" ? current + 1 : Math.max(0, current - 1);
        changeLineByKey(key, next);
      });
    });
    $$("[data-klassey-cart-remove]", d).forEach(function (btn) {
      btn.addEventListener("click", function () { changeLineByKey(btn.getAttribute("data-key"), 0); });
    });
  }

  // ===============================================================
  // Search drawer + predictive
  // ===============================================================
  var SEARCH_SEL = "[data-klassey-search-drawer]";

  function openSearch() {
    var d = $(SEARCH_SEL); if (!d) return;
    d.setAttribute("aria-hidden", "false");
    d.classList.remove("pointer-events-none");
    var ov = $("[data-klassey-search-overlay]", d);
    var pn = $("[data-klassey-search-panel]", d);
    if (ov) { ov.classList.remove("opacity-0"); ov.classList.add("opacity-100"); }
    if (pn) pn.classList.remove("-translate-y-full");
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      var inp = $("[data-klassey-search-input]", d);
      if (inp) inp.focus();
    }, 300);
  }
  function closeSearch() {
    var d = $(SEARCH_SEL); if (!d) return;
    d.setAttribute("aria-hidden", "true");
    var ov = $("[data-klassey-search-overlay]", d);
    var pn = $("[data-klassey-search-panel]", d);
    if (ov) { ov.classList.add("opacity-0"); ov.classList.remove("opacity-100"); }
    if (pn) pn.classList.add("-translate-y-full");
    setTimeout(function () { d.classList.add("pointer-events-none"); }, 300);
    document.body.style.overflow = "";
  }

  function renderPredictive(json, container) {
    var resources = json.resources && json.resources.results;
    if (!resources) return;
    var products = resources.products || [];
    var collections = resources.collections || [];
    var pages = resources.pages || [];
    var articles = resources.articles || [];

    var html = "";

    if (products.length) {
      html += '<div class="mb-stack-lg"><h3 class="font-label-sm text-label-sm uppercase tracking-widest text-on-surface-variant mb-stack-md">produtos</h3><div class="grid grid-cols-2 md:grid-cols-4 gap-stack-md">';
      products.forEach(function (p) {
        var img = p.featured_image ? p.featured_image.url : (p.image || "");
        var imgWebp = img ? img.replace(/(\.[^.]+)$/, '_240x$1') : '';
        html += '<a href="' + p.url + '" class="group flex flex-col gap-2">';
        if (imgWebp) html += '<div class="aspect-square overflow-hidden bg-surface-container-low rounded-md"><img src="' + imgWebp + '" alt="' + escapeHtml(p.title) + '" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy"></div>';
        html += '<div class="text-center"><p class="font-body-md text-[14px] text-on-surface line-clamp-2">' + escapeHtml(p.title).toLowerCase() + '</p>';
        if (p.price) html += '<p class="font-label-sm text-label-sm text-primary mt-1">' + p.price + '</p>';
        html += '</div></a>';
      });
      html += '</div></div>';
    }

    if (collections.length) {
      html += '<div class="mb-stack-lg"><h3 class="font-label-sm text-label-sm uppercase tracking-widest text-on-surface-variant mb-stack-md">coleções</h3><ul class="space-y-2">';
      collections.forEach(function (c) {
        html += '<li><a href="' + c.url + '" class="font-body-md text-body-md text-on-surface hover:text-primary transition-colors">' + escapeHtml(c.title).toLowerCase() + '</a></li>';
      });
      html += '</ul></div>';
    }

    if (pages.length || articles.length) {
      html += '<div><h3 class="font-label-sm text-label-sm uppercase tracking-widest text-on-surface-variant mb-stack-md">páginas & artigos</h3><ul class="space-y-2">';
      pages.concat(articles).forEach(function (item) {
        html += '<li><a href="' + item.url + '" class="font-body-md text-body-md text-on-surface hover:text-primary transition-colors">' + escapeHtml(item.title).toLowerCase() + '</a></li>';
      });
      html += '</ul></div>';
    }

    if (!html) html = '<p class="font-body-md text-on-surface-variant">nenhum resultado para esta busca.</p>';

    container.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function bindSearchHandlers() {
    var d = $(SEARCH_SEL); if (!d) return;
    var ov = $("[data-klassey-search-overlay]", d);
    if (ov) ov.addEventListener("click", closeSearch);
    $$("[data-klassey-search-close]", d).forEach(function (b) { b.addEventListener("click", closeSearch); });

    var input = $("[data-klassey-search-input]", d);
    var output = $("[data-klassey-search-output]", d);
    var defaultBlock = $("[data-klassey-search-default]", d);

    if (input && output) {
      var doSearch = debounce(function (q) {
        if (!q || q.length < 2) {
          output.classList.add("hidden");
          if (defaultBlock) defaultBlock.classList.remove("hidden");
          return;
        }
        if (defaultBlock) defaultBlock.classList.add("hidden");
        output.classList.remove("hidden");
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) +
              "&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last", {
          credentials: "same-origin",
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderPredictive(data, output); })
          .catch(function (err) { console.warn("klassey: predictive failed", err); });
      }, 220);

      input.addEventListener("input", function () { doSearch(this.value.trim()); });
    }
  }

  // ===============================================================
  // Wishlist
  // ===============================================================
  // Fluxo (versão atual):
  //  - Visitante clica em qualquer ❤ (card ou PDP): salva handle pendente em
  //    localStorage e redireciona pra /account/login?return_url=/pages/wishlist.
  //    Depois do login Shopify cuida do redirect; ao chegar na wishlist o JS
  //    materializa o pendente na lista do customer.
  //  - Cliente logado: toggle direto, sem reload. Chave de storage é
  //    "klassey_wl_<customerId>" pra não vazar entre contas no mesmo browser.
  //  - Server-side: produto-card faz fallback de leitura via
  //    customer.metafields.klassey.wishlist (caso um dia exista um app
  //    sincronizando via Admin API). Sem app, fica só localStorage.
  function getWishlistKey() {
    var cid = document.body.getAttribute("data-customer-id") || "guest";
    return "klassey_wl_" + cid;
  }
  var WISHLIST_PENDING_KEY = "klassey_wishlist_pending_v2";

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(getWishlistKey()) || "[]"); }
    catch (e) { return []; }
  }
  function writeWishlist(arr) {
    try { localStorage.setItem(getWishlistKey(), JSON.stringify(arr)); }
    catch (e) {}
  }

  function syncBadgeToButton(btn, active) {
    var icon = btn.querySelector(".material-symbols-outlined");
    if (!icon) return;
    if (active) {
      icon.classList.remove("text-on-surface-variant");
      icon.classList.add("text-tertiary-container");
      icon.style.fontVariationSettings = "'FILL' 1";
      btn.setAttribute("data-active", "true");
      btn.setAttribute("aria-label", "remover dos favoritos");
    } else {
      icon.classList.add("text-on-surface-variant");
      icon.classList.remove("text-tertiary-container");
      icon.style.fontVariationSettings = "";
      btn.removeAttribute("data-active");
      btn.setAttribute("aria-label", "adicionar aos favoritos");
    }
  }

  function bindWishlistHandlers() {
    var isLoggedIn = document.body.getAttribute("data-customer-logged-in") === "true";
    var loginUrl = document.body.getAttribute("data-account-login-url") || "/account/login";
    var wishlistUrl = "/pages/wishlist";

    // Recém-logou e tem intent pendente — materializa antes de pintar UI.
    if (isLoggedIn) {
      try {
        var pending = JSON.parse(localStorage.getItem(WISHLIST_PENDING_KEY) || "null");
        if (pending && pending.handle) {
          var current = readWishlist();
          if (current.indexOf(pending.handle) === -1) current.push(pending.handle);
          writeWishlist(current);
          localStorage.removeItem(WISHLIST_PENDING_KEY);
        }
      } catch (e) { localStorage.removeItem(WISHLIST_PENDING_KEY); }
    }

    var list = readWishlist();
    $$("[data-klassey-wishlist]").forEach(function (btn) {
      var handle = btn.getAttribute("data-product-handle");
      if (!handle) return;
      var serverActive = btn.getAttribute("data-active") === "true";
      var localActive = list.indexOf(handle) !== -1;
      var active = serverActive || localActive;
      if (active && !localActive) { list.push(handle); }
      syncBadgeToButton(btn, active);
    });
    writeWishlist(list);

    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-klassey-wishlist]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute("data-product-handle");
      if (!handle) return;

      // Visitante: salva intent e manda pra login, depois pra /pages/wishlist.
      if (!isLoggedIn) {
        try {
          localStorage.setItem(WISHLIST_PENDING_KEY, JSON.stringify({
            handle: handle,
            ts: Date.now(),
          }));
        } catch (err) {}
        var sep = loginUrl.indexOf("?") === -1 ? "?" : "&";
        window.location.href = loginUrl + sep + "return_url=" + encodeURIComponent(wishlistUrl);
        return;
      }

      // Cliente logado: toggle direto.
      var arr = readWishlist();
      var idx = arr.indexOf(handle);
      if (idx === -1) arr.push(handle);
      else arr.splice(idx, 1);
      writeWishlist(arr);

      syncBadgeToButton(btn, idx === -1);

      document.dispatchEvent(new CustomEvent("klassey:wishlist:change", {
        detail: { handle: handle, active: idx === -1, all: arr },
      }));
    });
  }

  // ===============================================================
  // PDP — botões +/- de quantidade (event delegation)
  // ===============================================================
  function bindPdpQty() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-klassey-pdp-qty]");
      if (!btn) return;
      e.preventDefault();
      var form = btn.closest("form");
      var input = form && form.querySelector("[data-klassey-pdp-qty-input]");
      if (!input) return;
      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.getAttribute("min"), 10) || 1;
      var action = btn.getAttribute("data-klassey-pdp-qty");
      input.value = action === "increase" ? current + 1 : Math.max(min, current - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // ===============================================================
  // Mobile menu
  // ===============================================================
  function bindMobileMenu() {
    var d = $("[data-klassey-mobile-menu]"); if (!d) return;
    var overlay = $("[data-klassey-mobile-menu-overlay]", d);
    var panel = d.querySelector("aside");

    function open() {
      d.setAttribute("aria-hidden", "false");
      d.classList.remove("pointer-events-none");
      if (overlay) { overlay.classList.remove("opacity-0"); overlay.classList.add("opacity-100"); }
      if (panel) panel.classList.remove("-translate-x-full");
      document.body.style.overflow = "hidden";
    }
    function close() {
      d.setAttribute("aria-hidden", "true");
      if (overlay) { overlay.classList.add("opacity-0"); overlay.classList.remove("opacity-100"); }
      if (panel) panel.classList.add("-translate-x-full");
      setTimeout(function () { d.classList.add("pointer-events-none"); }, 300);
      document.body.style.overflow = "";
    }

    $$("[data-klassey-mobile-menu-trigger]").forEach(function (b) { b.addEventListener("click", open); });
    $$("[data-klassey-mobile-menu-close]").forEach(function (b) { b.addEventListener("click", close); });
    if (overlay) overlay.addEventListener("click", close);
  }

  // ===============================================================
  // PDP gallery thumbnail sync
  // ===============================================================
  function bindGallery() {
    $$("[data-klassey-gallery]").forEach(function (gallery) {
      var mainImg = gallery.querySelector("[data-klassey-gallery-main]");
      var thumbs = $$("[data-klassey-gallery-thumb]", gallery);
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-src");
          var alt = thumb.getAttribute("data-alt") || "";
          if (mainImg && src) { mainImg.src = src; mainImg.alt = alt; }
          thumbs.forEach(function (t) { t.classList.remove("ring-2", "ring-primary"); });
          thumb.classList.add("ring-2", "ring-primary");
        });
      });
    });
  }

  // ===============================================================
  // Sticky add-to-cart mobile (PDP)
  // ===============================================================
  // Observa o form principal de produto. Quando ele sai do viewport,
  // mostra a barra fixa no rodapé com miniatura + preço + CTA.
  function bindStickyAtc() {
    var bar = $("[data-klassey-sticky-atc]");
    var target = $("[data-klassey-sticky-atc-target]");
    if (!bar || !target || typeof IntersectionObserver === "undefined") return;

    // Só usa em mobile (<lg = 1024px). Em desktop o form principal está sempre acessível.
    var mq = window.matchMedia("(max-width: 1023px)");

    function show() {
      bar.setAttribute("aria-hidden", "false");
      bar.classList.remove("translate-y-full", "opacity-0", "pointer-events-none");
    }
    function hide() {
      bar.setAttribute("aria-hidden", "true");
      bar.classList.add("translate-y-full", "opacity-0", "pointer-events-none");
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!mq.matches) { hide(); return; }
      entries.forEach(function (entry) {
        if (entry.isIntersecting) hide();
        else show();
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0 });

    observer.observe(target);

    // Se redimensionar pra desktop, esconde.
    mq.addEventListener("change", function (e) { if (!e.matches) hide(); });
  }

  // ===============================================================
  // Recently viewed (PDP save + hydrate carousel)
  // ===============================================================
  var RV_KEY = "klassey_recently_viewed_v1";
  var RV_MAX = 12;

  function bindRecentlyViewed() {
    var container = $("[data-klassey-recently-viewed]");
    if (!container) return;
    var currentHandle = container.getAttribute("data-current-handle");

    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || "[]"); } catch (e) { list = []; }

    if (currentHandle) {
      list = list.filter(function (h) { return h !== currentHandle; });
      list.unshift(currentHandle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, RV_MAX))); } catch (e) {}
    }

    var toShow = list.filter(function (h) { return h !== currentHandle; }).slice(0, 6);
    if (toShow.length === 0) return;

    var slots = $$("[data-klassey-recently-viewed-slot]", container);

    Promise.all(toShow.map(function (handle) {
      return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var filled = 0;
      products.forEach(function (p, idx) {
        if (!p || !slots[idx]) return;
        var slot = slots[idx];
        var img = p.featured_image || (p.images && p.images[0]) || "";
        var price = (p.price / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        slot.innerHTML =
          '<a href="/products/' + p.handle + '" class="block group">' +
            '<div class="aspect-square bg-surface-container-low rounded-lg overflow-hidden mb-stack-md">' +
              (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">' : '') +
            '</div>' +
            '<div class="text-center">' +
              '<h3 class="font-headline-md text-[16px] text-on-surface mb-1">' + escapeHtml(p.title).toLowerCase() + '</h3>' +
              '<p class="font-body-md text-primary font-medium">' + price + '</p>' +
            '</div>' +
          '</a>';
        slot.classList.remove("hidden", "animate-pulse");
        filled++;
      });
      if (filled > 0) container.classList.remove("hidden");
    });
  }

  // ===============================================================
  // Back-in-stock notify form
  // ===============================================================
  function bindBackInStock() {
    $$("[data-klassey-bis-form]").forEach(function (form) {
      var msg = form.querySelector("[data-klassey-bis-msg]");
      var btn = form.querySelector("[data-klassey-bis-submit]");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent.trim(); btn.textContent = "enviando..."; }
        fetch("/contact#contact_form", {
          method: "POST",
          credentials: "same-origin",
          body: new FormData(form)
        }).then(function () {
          if (msg) { msg.textContent = "tudo certo. avisaremos no email assim que voltar."; msg.classList.add("text-primary"); }
          form.reset();
        }).catch(function () {
          if (msg) { msg.textContent = "ops, tente de novo daqui a pouco."; msg.classList.add("text-error"); }
        }).finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || "avisar"; }
        });
      });
    });
  }

  // ===============================================================
  // Delivery estimate (today + N business days, with cutoff)
  // ===============================================================
  function bindDeliveryEstimate() {
    var weekdays = ["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"];
    var months = ["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"];
    $$("[data-klassey-delivery]").forEach(function (el) {
      var dayTarget = el.querySelector("[data-klassey-delivery-date]");
      var hintTarget = el.querySelector("[data-klassey-delivery-hint]");
      if (!dayTarget) return;
      var businessDays = parseInt(el.getAttribute("data-business-days"), 10) || 2;
      var cutoffHour = parseInt(el.getAttribute("data-cutoff-hour"), 10) || 14;
      var now = new Date();
      var d = new Date(now);
      if (now.getHours() >= cutoffHour) d.setDate(d.getDate() + 1);
      var added = 0;
      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        var dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      dayTarget.textContent = weekdays[d.getDay()] + ", " + d.getDate() + " " + months[d.getMonth()];
      if (hintTarget) {
        if (now.getHours() >= cutoffHour) {
          hintTarget.textContent = "pedidos após " + cutoffHour + "h saem no próximo dia útil";
        } else {
          var hoursLeft = cutoffHour - now.getHours();
          hintTarget.textContent = "compre nas próximas " + hoursLeft + "h pra postar hoje";
        }
      }
    });
  }

  // ===============================================================
  // Frenet shipping calculator (PDP)
  // ===============================================================
  // Posta no worker Cloudflare existente (esconde token Frenet).
  // Worker URL configurável via data-frenet-url no snippet.
  function bindFrenetCalc() {
    $$("[data-klassey-frenet]").forEach(function (root) {
      var url = root.getAttribute("data-frenet-url");
      var input = root.querySelector("[data-klassey-frenet-cep]");
      var btn = root.querySelector("[data-klassey-frenet-btn]");
      var msg = root.querySelector("[data-klassey-frenet-msg]");
      var results = root.querySelector("[data-klassey-frenet-results]");
      if (!url || !input || !btn || !results) return;

      function onlyDigits(s) { return String(s || "").replace(/\D/g, "").slice(0, 8); }
      function formatCEP(s) {
        var d = onlyDigits(s);
        return d.length > 5 ? d.slice(0, 5) + "-" + d.slice(5) : d;
      }
      function money(n) {
        var v = parseFloat(String(n).replace(",", "."));
        if (!isFinite(v)) return String(n);
        return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
      }
      function showMsg(text, kind) {
        msg.style.display = "block";
        msg.textContent = text;
        msg.classList.remove("text-primary", "text-error");
        if (kind === "error") msg.classList.add("text-error");
        else if (kind === "ok") msg.classList.add("text-primary");
      }
      function clearMsg() { msg.style.display = "none"; msg.textContent = ""; }
      function clearResults() { results.innerHTML = ""; }
      function setLoading(on) {
        btn.disabled = !!on;
        btn.textContent = on ? "calculando..." : "calcular";
      }

      function render(data) {
        clearResults();
        var services = data && data.ShippingSevicesArray;
        if (!services || !services.length) {
          results.innerHTML = '<div class="font-body-md text-[13px] text-on-surface-variant border border-dashed border-outline-variant rounded-lg p-stack-md">nenhuma transportadora atende esse cep no momento.</div>';
          return;
        }
        var valid = services
          .filter(function (s) { return !s.Error && parseFloat(s.ShippingPrice) > 0; })
          .sort(function (a, b) { return parseFloat(a.ShippingPrice) - parseFloat(b.ShippingPrice); });
        if (!valid.length) {
          results.innerHTML = '<div class="font-body-md text-[13px] text-on-surface-variant border border-dashed border-outline-variant rounded-lg p-stack-md">nenhuma transportadora atende esse cep no momento.</div>';
          return;
        }
        var frag = document.createDocumentFragment();
        valid.forEach(function (s, idx) {
          var name = (s.ServiceDescription || s.Carrier || "frete").trim().toLowerCase();
          var carrier = (s.Carrier || "").trim().toLowerCase();
          // Prazo direto da transportadora (sem buffer adicional).
                      var days = s.DeliveryTime != null ? parseInt(s.DeliveryTime, 10) + " dias úteis" : "";
          var metaParts = [];
          if (carrier && carrier !== name) metaParts.push(carrier);
          if (days) metaParts.push(days);
          var row = document.createElement("div");
          row.className = "flex items-center justify-between gap-3 border border-outline-variant rounded-lg px-3 py-2 bg-surface hover:border-primary transition-colors";
          row.innerHTML =
            '<div class="flex flex-col min-w-0">' +
              '<p class="font-label-sm text-[13px] text-on-surface font-medium leading-tight">' + escapeHtml(name) +
                (idx === 0 ? ' <span class="ml-1 text-[10px] font-normal text-primary uppercase tracking-wider">mais barato</span>' : '') +
              '</p>' +
              (metaParts.length ? '<p class="font-body-md text-[11px] text-on-surface-variant">' + escapeHtml(metaParts.join(" · ")) + '</p>' : '') +
            '</div>' +
            '<span class="font-label-sm text-[14px] text-on-surface font-semibold whitespace-nowrap">' + money(s.ShippingPrice) + '</span>';
          frag.appendChild(row);
        });
        results.appendChild(frag);
      }

      function calcular() {
        clearMsg();
        clearResults();
        var d = onlyDigits(input.value);
        if (d.length !== 8) {
          showMsg("informe um cep válido (8 dígitos). ex: 01001-000", "error");
          input.focus();
          return;
        }
        setLoading(true);
        showMsg("buscando opções de entrega...");
        fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cep: d })
        })
          .then(function (r) {
            if (!r.ok) throw new Error("erro ao consultar frete (http " + r.status + ").");
            return r.json();
          })
          .then(function (data) {
            if (data && data.error) throw new Error(data.error);
            render(data);
            clearMsg();
          })
          .catch(function (err) {
            showMsg((err && err.message) || "não foi possível calcular o frete.", "error");
          })
          .finally(function () { setLoading(false); });
      }

      input.addEventListener("input", function () {
        input.value = formatCEP(input.value);
        clearMsg();
        clearResults();
      });
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") { e.preventDefault(); calcular(); }
      });
      btn.addEventListener("click", calcular);
      input.value = formatCEP(input.value);
    });
  }

  // ===============================================================
  // Global triggers
  // ===============================================================
  function bindGlobalTriggers() {
    $$("[data-klassey-cart-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    });
    $$("[data-klassey-search-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeCart(); closeSearch(); }
    });

    document.addEventListener("klassey:cart:open", openCart);
    document.addEventListener("klassey:cart:close", closeCart);
    document.addEventListener("klassey:cart:refresh", refreshCartDrawer);
    document.addEventListener("klassey:search:open", openSearch);

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      if (form.action && form.action.indexOf("/cart/add") !== -1) {
        addToCart(form, e);
      }
    });
  }

  function init() {
    bindGlobalTriggers();
    bindCartHandlers();
    bindSearchHandlers();
    bindWishlistHandlers();
    bindMobileMenu();
    bindGallery();
    bindPdpQty();
    bindStickyAtc();
    bindRecentlyViewed();
    bindBackInStock();
    bindDeliveryEstimate();
    bindFrenetCalc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
